module.exports = __webpack_public_path__ + "img/wait-times.f574b7d1.png";